var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgInfo = function SvgInfo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3.4c-4.742 0-8.6 3.858-8.6 8.6s3.858 8.6 8.6 8.6 8.6-3.857 8.6-8.6-3.858-8.6-8.6-8.6m0 16c-4.08 0-7.4-3.32-7.4-7.4S7.92 4.6 12 4.6c4.081 0 7.4 3.32 7.4 7.4s-3.319 7.4-7.4 7.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.8 10.5h-1.6v6h1.6zm0-3h-1.6v1.6h1.6z"
  })));
};
export { SvgInfo as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' d='M12 3.4c-4.742 0-8.6 3.858-8.6 8.6s3.858 8.6 8.6 8.6 8.6-3.857 8.6-8.6-3.858-8.6-8.6-8.6m0 16c-4.08 0-7.4-3.32-7.4-7.4S7.92 4.6 12 4.6c4.081 0 7.4 3.32 7.4 7.4s-3.319 7.4-7.4 7.4'/%3e%3cpath fill='currentColor' d='M12.8 10.5h-1.6v6h1.6zm0-3h-1.6v1.6h1.6z'/%3e%3c/svg%3e";